import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { DocCheck } from '../../docs/components/DocCheck';
import { PrejimkaMenu } from '../../prejimka/prejimkamenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const PrejimkaNewCheckPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.prejimka ? (
        <AppWrapper
          appType={APP_TYPE.PREJIMKA}
          menu={<PrejimkaMenu />}
        >
          <DocCheck />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default PrejimkaNewCheckPage;
